import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { LocalHospital } from '@material-ui/icons';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import { useHistory } from "react-router-dom";
import AlertModal from '../../../../shared/components/Modal';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

import RadioPharmacyMedicine from '../../api/radiopharmacy_medicine_api';


const UpdateRadioPharmacy = ({ updateRadioPharmacyModal, closeRadioPharmacyModal, opened, radiofarmacia }) => {
    const history = useHistory();

    //Modal
    const [openModal, setOpenModal] = React.useState(opened);

    //Radio Farmacos
    const [medicines, setMedicines] = React.useState([]);

    //Atributos SOLO RADIOFARMACIA
    const [idRadioFarmacia, setIdRadioFarmacia] = React.useState(radiofarmacia.id_radiofarmacia);
    const [hourMark, setHourMark] = React.useState(radiofarmacia.hora_marcado != null ? new Date('2021-06-09T' + radiofarmacia.hora_marcado) : null);
    const [hourAdmon, setHourAdmon] = React.useState(radiofarmacia.hora_admon != null ? new Date('2021-06-09T' + radiofarmacia.hora_admon) : null);
    const [radioFarmaco, setRadioFarmaco] = React.useState(null);
    const [radioFarmacoNombre, setRadioFarmacoNombre] = React.useState(null);
    const [viaAdmon, setViaAdmon] = React.useState(radiofarmacia.via_admon);
    const [lote, setLote] = React.useState(parseFloat(radiofarmacia.lote));
    const [loteVial, setLoteVial] = React.useState(parseFloat(radiofarmacia.lote_vial));
    const [conservar, setConservar] = React.useState(radiofarmacia.conservar);
    const [estabilidad, setEstabilidadHoras] = React.useState(parseFloat(radiofarmacia.estabilidad));
    const [actividadMBQ, setActivityMBQ] = React.useState(radiofarmacia.actividad);
    const [precalMBQ, setPrecalMBQ] = React.useState(radiofarmacia.precal);
    const [firma, setFirma] = React.useState(radiofarmacia.firma);

    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {
        consultarFarmacos();
    }, []);

    const consultarFarmacos = async () => {
        let farmacos = await RadioPharmacyMedicine.listMedicine();
        setMedicines(farmacos.contenido);
    }

    const grabarCitaConRadiofarmacologia = () => {
        console.log(medicines);
        //Si no existe la Radiofarmacia se le crea una
        if (idRadioFarmacia == null) {
            console.log("CREANDO");
        }
        else {
            console.log("ACTUALIZANDO");
        }
    }

    const validarRadioFarmaco = (event) => {

        if(event.target.value != null)
        {
            let farmaco = event.target.value;
            setRadioFarmaco(farmaco);
            setRadioFarmacoNombre(farmaco.farmaco);
            setEstabilidadHoras(parseFloat(farmaco.estabilidad));
            setConservar(farmaco.conservacion);
        }
    }

    const validarActividadMBQ = (event) => {
        if(event.target.value != null)
        {
            let actividad_mbq = event.target.value;
            setActivityMBQ(actividad_mbq);
        }
    }

    const calcularPrecalibracion = () => {
        /**Se halla primero el Tiempo en Hora Militar */








        let precalibrado = actividadMBQ;
        setPrecalMBQ(precalibrado);
    }

    const verifyCloseModal = () => {
        setAlerShowModal(false);

        if (colorAlertModal == "success") {
            let _url = "/radio-pharmacy/list";

            if (colorAlertModal == "success") {
                if (window.location.pathname === process.env.PUBLIC_URL + _url) {
                    history.replace(process.env.PUBLIC_URL );
                    setTimeout(() => {
                        history.replace({
                            pathname: process.env.PUBLIC_URL + _url
                        });
                    }, 0);
                } else {
                    history.push({
                        pathname: process.env.PUBLIC_URL +_url
                    });
                }
            }
        }
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                    closeRadioPharmacyModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Detalles</h5>
                        </div>
                        <Row>
                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardTimePicker
                                        style={{ minWidth: '200px', maxWidth: '100%' }}
                                        mask="__:__ _M"
                                        id="input-hora-marcado"
                                        value={hourMark}
                                        className="medical-material-form__field"
                                        onChange={(value) => {
                                            setHourMark(value);
                                        }}
                                        label="Hora Marcado"
                                        onError={console.log}
                                        format="hh:mm a"
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink:true
                                        }}
                                        className="medical-material-form__field"
                                        keyboardIcon={<FontAwesomeIcon icon={faClock} />}
                                    />
                                </MuiPickersUtilsProvider>
                                <br />
                            </Col>

                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardTimePicker
                                        style={{ minWidth: '200px', maxWidth: '100%' }}
                                        mask="__:__ _M"
                                        id="input-hora-admon"
                                        value={hourAdmon}
                                        className="medical-material-form__field"
                                        onChange={(value) => {
                                            setHourAdmon(value);
                                        }}
                                        label="Hora Admon"
                                        onError={console.log}
                                        format="hh:mm a"
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink:true
                                        }}
                                        className="medical-material-form__field"
                                        keyboardIcon={<FontAwesomeIcon icon={faClock} />}
                                    />
                                </MuiPickersUtilsProvider>
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="text"
                                    label="Nombre del Paciente"
                                    value={radiofarmacia.nombre_paciente}
                                    defaultValue={radiofarmacia.nombre_paciente}
                                    disabled={true}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="text"
                                    label="Edad"
                                    value={radiofarmacia.edad}
                                    defaultValue={radiofarmacia.edad}
                                    disabled={true}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="text"
                                    label="Estudio"
                                    value={radiofarmacia.estudio}
                                    defaultValue={radiofarmacia.estudio}
                                    disabled={true}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="text"
                                    label="Número de Documento"
                                    value={radiofarmacia.num_documento}
                                    defaultValue={radiofarmacia.num_documento}
                                    disabled={true}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    id="select_radiofarmaco"
                                    select
                                    label="Radiofármaco"
                                    value={radioFarmaco}
                                    defaultValue={radioFarmaco}
                                    className='medical-material-form__field'
                                    onChange={(event) => {
                                        validarRadioFarmaco(event);
                                    }}

                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}

                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                >
                                    {medicines.map((med) => {
                                        return <MenuItem key={med.id_rac_farmaco} value={med}>
                                            {med.farmaco}
                                        </MenuItem>
                                    })}
                                </TextField>
                                <br />
                            </Col>


                            <Col md={4}>
                                <TextField
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="text"
                                    label="Via Admon"
                                    value={viaAdmon}
                                    defaultValue={viaAdmon}
                                    //disabled={true}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>


                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        setLote(e.target.value);
                                    }}
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="number"
                                    label="Lote de Actividad"
                                    value={lote}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>



                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        setLoteVial(e.target.value);
                                    }}
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="number"
                                    label="Lote Vial"
                                    value={loteVial}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        setConservar(e.target.value);
                                    }}
                                    //placeholder="Conservar (°C)"
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    label="Conservar (°C)"
                                    value={conservar}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        setEstabilidadHoras(e.target.value);
                                    }}
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="number"
                                    label="Estabilidad (Horas)"
                                    value={estabilidad}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        validarActividadMBQ(e);
                                        
                                    }}
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid-activitymbq"
                                    type="number"
                                    label="Actividad (MBQ)"
                                    value={actividadMBQ}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        setPrecalMBQ(e.target.value);
                                    }}
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid-activitymbq"
                                    type="text"
                                    label="Precal (MBQ)"
                                    value={precalMBQ}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>

                            <Col md={4}>
                                <TextField
                                    onChange={(e) => {
                                        setFirma(e.target.value);
                                    }}
                                    style={{ minWidth: '175px', maxWidth: '100%' }}
                                    id="input-with-icon-grid"
                                    type="text"
                                    label="Firma"
                                    value={firma}
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink:true
                                    }}
                                    className="medical-material-form__field"
                                />
                                <br />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            className="btn btn-sm"
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                grabarCitaConRadiofarmacologia();
                            }}
                        >
                            Guardar
                        </Button>
                        <Button
                            className="btn btn-sm"
                            style={{ marginTop: 10 }}
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                setOpenModal(false);
                                closeRadioPharmacyModal(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => verifyCloseModal()}
                toggle={() => verifyCloseModal()}
            />
        </div>
    );
};
export default UpdateRadioPharmacy;
